export const gradients = {
    nausPurple: ['#9e7ae6', '#5f27cd'],
  }
  
  export const colors = {
    // Pallete
    pinkRed: '#EF3340',
    goldenPoppy: '#FFC600',
    darkPinkRed: '#7C2629',
    mistyRose: '#fdeaec',
    mediumMistyRose: '#f5aeb5',
    darkMistyRose: '#f58490',
    darkerMistyRose: '#f56978',
    greenCyan: '#26D07C',
    lightGray: '#d3d3d3',
    lighterGray: '#ededed',
    backgroundGray: '#E1E1E1',
    gray: '#646464',
    darkGray: '#101820',
    wetAsphalt: '#486280',
    midNightBlue: '#2C3E50',
    white: '#FFF',
  }
  
  export const complementarColors = {
    // Other colors
  
    amethyst: '#9b59b6',
    emerald: '#2ecc71',
    turquoise: '#1abc9c',
    alizarin: '#e74c3c',
    orange: '#f39c12',
    nephritis: '#27ae60',
    pomegranate: '#c0392b',
  }
  
  export const oppositionColors = {
    normal: '#0652DD',
    opposition: '#c23616',
  }
  